module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('div', {
    staticClass: "order-success"
  }), _vm._v(" "), _vm._l((_vm.formData.list), function(item, index) {
    return _c('div', [_c('van-divider', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.exame_status == 1) ? _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "text-align": "center"
      }
    }, [_c('van-button', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'H5',
          query: {
            url: item.url
          }
        }),
        expression: "{name:'H5' ,query:{ url:item.url }}"
      }],
      staticStyle: {
        "width": "3rem",
        "margin": "0 auto"
      },
      attrs: {
        "size": "normal",
        "round": ""
      }
    }, [_vm._v("进入考试")])], 1) : _vm._e(), _vm._v(" "), (item.exame_status == 3) ? _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "场次",
        "value": item.saiqu
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "报名ID ",
        "value": item.sojumpparm
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "姓名 ",
        "value": item.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "身份证 ",
        "value": item.num
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "得分 ",
        "value": item.totalvalue
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "总分 ",
        "value": item.fullscore
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.exame_status == 3) ? _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "text-align": "center"
      }
    }, [_c('van-button', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'H5',
          query: {
            url: item.result_url
          }
        }),
        expression: "{name:'H5' ,query:{ url:item.result_url }}"
      }],
      staticStyle: {
        "width": "3rem",
        "margin": "0 auto"
      },
      attrs: {
        "size": "normal",
        "round": ""
      }
    }, [_vm._v("查看解析")])], 1) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8f52612","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/songpei/SongpeiExame.vue
// module id = 2586
// module chunks = 0